import React from 'react';
import { components } from 'react-select';

function ClearIndicator(props) {
  const { innerProps, ...rest } = props;
  const newInnerProps: any = {
    ...innerProps,
    onMouseDown: (e: any) => {
      e.stopPropagation();
      innerProps.onMouseDown && innerProps.onMouseDown(e);
    },
    onTouchEnd: (e: any) => {
      e.stopPropagation();
      innerProps.onTouchEnd && innerProps.onTouchEnd(e);
    },
  };

  const newProps = {
    ...rest,
    innerProps: newInnerProps,
  };

  return <components.ClearIndicator {...newProps} />;
}

export default ClearIndicator;
